(() => {
  const sectionSelector = '[data-akbar-collection-carousel]';

  const updateControls = (section) => {
    const list = section.querySelector('.AkbarCollectionCarousel__list');
    const carousel = section.querySelector('.AkbarCollectionCarousel__track');
    const previous = section.querySelector('[data-akbar-carousel-action="previous"]');
    const next = section.querySelector('[data-akbar-carousel-action="next"]');

    if (!list || !carousel || !previous || !next) {
      return;
    }

    const maximumScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
    const atStart = carousel.scrollLeft <= 1;
    const atEnd = carousel.scrollLeft >= maximumScroll - 1;
    previous.disabled = atStart;
    next.disabled = atEnd;
    list.dataset.akbarCarouselAtEnd = String(atEnd);
    list.dataset.akbarCarouselScrollable = String(maximumScroll > 1);
  };

  const finishMouseDrag = (carousel, state, event) => {
    if (event.pointerId !== state.pointerId) {
      return;
    }

    state.suppressClick = state.moved;
    state.pointerId = null;
    carousel.classList.remove('is-dragging');
    if (carousel.hasPointerCapture(event.pointerId)) {
      carousel.releasePointerCapture(event.pointerId);
    }
    window.setTimeout(() => { state.suppressClick = false; }, 100);
  };

  const initializeMouseDrag = (carousel) => {
    const state = { pointerId: null, startX: 0, startScrollLeft: 0, moved: false, suppressClick: false };

    carousel.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) {
        return;
      }

      state.pointerId = event.pointerId;
      state.startX = event.clientX;
      state.startScrollLeft = carousel.scrollLeft;
      state.moved = false;
    });

    carousel.addEventListener('pointermove', (event) => {
      if (event.pointerId !== state.pointerId || event.buttons !== 1) {
        return;
      }

      const distance = event.clientX - state.startX;
      if (Math.abs(distance) > 8) {
        state.moved = true;
        if (!carousel.hasPointerCapture(event.pointerId)) {
          carousel.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        carousel.classList.add('is-dragging');
        carousel.scrollLeft = state.startScrollLeft - distance;
      }
    });

    carousel.addEventListener('pointerup', (event) => finishMouseDrag(carousel, state, event));
    carousel.addEventListener('pointercancel', (event) => finishMouseDrag(carousel, state, event));
    carousel.addEventListener('click', (event) => {
      if (!state.suppressClick) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      state.suppressClick = false;
    }, true);
  };

  const initialize = (section) => {
    if (section.dataset.akbarCollectionCarouselReady === 'true') {
      return;
    }

    const carousel = section.querySelector('.AkbarCollectionCarousel__track');
    const previous = section.querySelector('[data-akbar-carousel-action="previous"]');
    const next = section.querySelector('[data-akbar-carousel-action="next"]');

    if (!carousel || !previous || !next) {
      return;
    }

    section.dataset.akbarCollectionCarouselReady = 'true';

    previous.addEventListener('click', () => {
      carousel.scrollBy({ left: -carousel.clientWidth, behavior: 'auto' });
    });

    next.addEventListener('click', () => {
      carousel.scrollBy({ left: carousel.clientWidth, behavior: 'auto' });
    });

    carousel.addEventListener('scroll', () => updateControls(section), { passive: true });
    initializeMouseDrag(carousel);
    new ResizeObserver(() => updateControls(section)).observe(carousel);
    updateControls(section);
  };

  const initializeAll = () => document.querySelectorAll(sectionSelector).forEach(initialize);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches?.(sectionSelector)) {
      initialize(event.target);
    }
  });
})();
